/**
 * video-editor/overlay.js — рисование надписей поверх кадра.
 *
 * ⚠️⚠️ ЭТОТ МОДУЛЬ ЗОВУТ ДВОЕ: превью и экспорт. Именно поэтому он вынесен, а
 * не написан дважды по месту. Замер 24.08 на /audio-enhancer показал цену
 * второй копии: предпрослушка гоняла не ту цепочку, что выдача, и жалоба «в
 * предпросмотре вау, на выходе ужас» оказалась буквально верной. Здесь то же
 * самое читалось бы как «надпись на экране в одном месте, в файле в другом».
 *
 * Всё измеряется В ДОЛЯХ КАДРА и переводится в пиксели ЗДЕСЬ. Превью рисует в
 * канву ~640 px шириной, экспорт — в 1920. Если бы размеры хранились в
 * пикселях, надпись, поставленная в превью, уезжала бы при экспорте — молча и
 * всегда.
 *
 * ⚠️ Направление абзаца берётся у ТЕКСТА, а не у страницы. Канва экспорта
 * ОффскринНАЯ, её `direction` — начальное `ltr` независимо от локали
 * страницы; на арабской странице превью и файл разошлись бы в порядке слов.
 * Тот же вывод уже сделан для визитки и сертификата — берём их общий
 * определитель `PdfTextFont.baseIsRtl` (UAX#9 P2/P3).
 *
 * ⚠️ Шрифты. Гарнитуры надписей — свои файлы сайта с кириллицей
 * (/fonts/cert, SIL OFL), объявлены @font-face в блейде редактора. Канва не
 * ждёт шрифт сама: нарисованный до загрузки текст выходит запасной
 * гарнитурой. Поэтому экспорт сначала ждёт ensureFonts(), а превью, увидев
 * незагруженный шрифт, просит загрузку и перерисовывается по её концу.
 *
 * window.VideoEditorOverlay:
 *   draw(ctx, items, W, H)   items — то, что вернул timeline.textsAt(t)
 *   boxOf(ctx, item, W, H)   → геометрия блока (рамка выделения, попадание мышью)
 *   ensureFonts(items)       → Promise: все гарнитуры этих надписей загружены
 *   onFontReady(fn)          — превью перерисуется, когда шрифт догрузится
 */
(function () {
'use strict';
if (window.VideoEditorOverlay) return;

var FALLBACK = '"Noto Sans Arabic","Segoe UI",system-ui,sans-serif';
/* Ключ модели → гарнитура и насыщенность. Имена семей объявлены в блейде. */
var FONTS = {
    sans: { fam: '"VE Montserrat"', w: 700 },
    narrow: { fam: '"VE Oswald"', w: 700 },
    serif: { fam: '"VE Playfair"', w: 700 },
    hand: { fam: '"VE Caveat"', w: 700 },
    display: { fam: '"VE Russo"', w: 400 },
    script: { fam: '"VE Lobster"', w: 400 },
};
var FONT_STACK = FONTS.sans.fam + ',' + FALLBACK;

function faceOf(item) { return FONTS[item && item.font] || FONTS.sans; }
function fontSpec(item, px) { var f = faceOf(item); return f.w + ' ' + px + 'px ' + f.fam + ',' + FALLBACK; }

/* ── загрузка гарнитур ────────────────────────────────────────────────── */
var readyHooks = [];
var asked = {};
function fontsApi() { return (typeof document !== 'undefined' && document.fonts && document.fonts.load) ? document.fonts : null; }
function isLoaded(item) {
    var F = fontsApi();
    if (!F || !F.check) return true;
    try { return F.check(fontSpec(item, 20), String(item.text || 'A').slice(0, 20)); } catch (e) { return true; }
}
function askLoad(item) {
    var F = fontsApi();
    if (!F) return Promise.resolve();
    var key = (item.font || 'sans');
    if (asked[key]) return asked[key];
    asked[key] = F.load(fontSpec(item, 20), 'AaЯя').then(function () {
        readyHooks.forEach(function (fn) { try { fn(); } catch (e) {} });
    }, function () {});
    return asked[key];
}
/** Все гарнитуры этих надписей загружены (не дольше ms). */
function ensureFonts(items, ms) {
    var list = (items || []).map(function (x) { return x && x.item ? x.item : x; }).filter(Boolean);
    var ps = list.map(function (it) { return askLoad(it); });
    return Promise.race([Promise.all(ps), new Promise(function (r) { setTimeout(r, ms || 5000); })]);
}

function isRtl(s) {
    try {
        if (window.PdfTextFont && window.PdfTextFont.baseIsRtl) return !!window.PdfTextFont.baseIsRtl(s);
    } catch (e) {}
    // Запасной путь ровно на случай, когда общий модуль не подключён: первый
    // сильный символ арабского/иврита. Это упрощённый P2/P3, и он тут ИМЕННО
    // как запасной — расходиться с общим определителем нельзя. Диапазоны —
    // RE_R / RE_L из pdf-text-font.js и ТОЛЬКО экранами: буквальные символы
    // здесь уже раз переписал редактор (U+FB1D разложился в U+05D9 U+05B4, и
    // диапазон «U+05B4–U+FDFF» записал в правостороннее корейский, японский,
    // китайский и хинди; U+FEFF лёг в файл как BOM). Сторож —
    // tests/js/video-editor-rtl-fallback.test.mjs.
    return /^[^A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF\u3040-\u30FF\u4E00-\u9FFF\uAC00-\uD7AF]*[\u0590-\u05FF\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\u0700-\u074F\u0750-\u077F\u08A0-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFE]/.test(String(s || ''));
}

function fontPx(item, H) { return Math.max(8, Math.round(H * (item.sizePct / 100))); }

function linesOf(item) {
    return String(item.text || '').split(/\r?\n/).filter(function (l, i, a) {
        return l.trim() !== '' || (i > 0 && i < a.length - 1);   // хвостовые пустые строки не двигают блок
    });
}

/* Перенос по ширине кадра. Длинная фраза иначе уходила за край и
   обрезалась в файле — человек видел это только в скачанном ролике
   (вертикальный кадр вдвое уже, и там это случалось с обычной фразой).
   Переносим по пробелам; слово длиннее строки (и текст без пробелов —
   китайский, японский) — по знакам. Ширина — у ТОЙ ЖЕ канвы и того же
   шрифта, что рисуют: превью 960 px и файл 4K переносят одинаково, потому
   что и шрифт, и ширина — доли кадра. */
var WRAP = 0.9;
function wrapLine(ctx, line, maxW) {
    function fits(x) { return ctx.measureText(x).width <= maxW; }
    if (!(maxW > 0) || fits(line)) return [line];
    var out = [], cur = '';
    function flush() { var t = cur.replace(/\s+$/, ''); if (t) out.push(t); cur = ''; }
    var tokens = line.split(/(\s+)/).filter(Boolean);
    for (var i = 0; i < tokens.length; i++) {
        var tk = tokens[i];
        if (/^\s+$/.test(tk)) { if (cur) cur += tk; continue; }
        if (fits(cur + tk)) { cur += tk; continue; }
        if (cur) flush();
        if (fits(tk)) { cur = tk; continue; }
        // Слово шире строки (или текст без пробелов) — по знакам.
        var chars = Array.from(tk);
        for (var c = 0; c < chars.length; c++) {
            if (cur && !fits(cur + chars[c])) flush();
            cur += chars[c];
        }
    }
    flush();
    return out.length ? out : [line];
}

/** Ширина/высота блока надписи в пикселях кадра. */
function measure(ctx, item, W, H) {
    var px = fontPx(item, H);
    ctx.save();
    ctx.font = fontSpec(item, px);
    var pad = Math.round(px * 0.35);
    var maxW = W * WRAP - pad * 2;
    var src = linesOf(item), lines = [], w = 0;
    for (var s = 0; s < src.length; s++) lines = lines.concat(wrapLine(ctx, src[s], maxW));
    for (var i = 0; i < lines.length; i++) {
        var m = ctx.measureText(lines[i]);
        if (m.width > w) w = m.width;
    }
    ctx.restore();
    var lh = Math.round(px * 1.25);
    return { w: w, h: lh * Math.max(1, lines.length), lineHeight: lh, fontPx: px, lines: lines };
}

/** '#rrggbb' + прозрачность → rgba(): цвет подложки выбирает человек. */
function rgba(hex, a) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
    var n = m ? parseInt(m[1], 16) : 0;
    return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
}

/**
 * @param {CanvasRenderingContext2D} ctx  канва кадра (уже с нарисованным видео)
 * @param {Array} items  [{item, alpha, pin, pout, local, span}] из timeline.textsAt(t)
 */
function draw(ctx, items, W, H) {
    if (!items || !items.length) return;
    for (var i = 0; i < items.length; i++) {
        var it = items[i].item, alpha = items[i].alpha;
        if (!it || !String(it.text || '').trim() || !(alpha > 0)) continue;
        if (!isLoaded(it)) askLoad(it);
        drawOne(ctx, it, alpha, W, H, items[i]);
    }
}

/**
 * Где блок надписи стоит в кадре — ОДИН расчёт и для рисования, и для рамки
 * выделения/попадания мышью в превью: две копии этой геометрии разошлись бы
 * ровно на краях кадра, где блок прижимается внутрь.
 */
function boxOf(ctx, it, W, H) {
    var m = measure(ctx, it, W, H);
    var cx = it.x * W;
    // y — доля кадра до ВЕРХА блока; так надпись не уползает вниз при росте
    // числа строк, чего пользователь не ожидает: он ставил её «сюда».
    var top = it.y * H;
    // Прижать блок внутрь кадра: надпись, наполовину уехавшая за край, в
    // экспорте просто обрежется, и человек этого не увидит до скачивания.
    if (top + m.h > H) top = H - m.h;
    if (top < 0) top = 0;
    var pad = Math.round(m.fontPx * 0.35);
    var boxX;
    if (it.align === 'left') boxX = cx;
    else if (it.align === 'right') boxX = cx - m.w;
    else boxX = cx - m.w / 2;
    if (boxX < pad) boxX = pad;
    if (boxX + m.w > W - pad) boxX = Math.max(pad, W - pad - m.w);
    return { m: m, x: boxX, y: top, w: m.w, h: m.h, pad: pad };
}

function easeOut(p) { return 1 - Math.pow(1 - p, 3); }
function easeBack(p) { var c = 1.7; return 1 + (c + 1) * Math.pow(p - 1, 3) + c * Math.pow(p - 1, 2); }

/* Печать: сколько знаков видно. Раскладка блока считается по ПОЛНОМУ тексту —
   иначе блок полз бы вместе с каждой буквой. */
var TYPE_SEC = 1.6;
function typedLines(lines, ph) {
    if (!ph) return lines;
    var total = 0;
    lines.forEach(function (l) { total += Array.from(l).length; });
    var dur = Math.min(TYPE_SEC, (ph.span || 1) * 0.6);
    var n = dur > 0 ? Math.ceil(total * Math.min(1, (ph.local || 0) / dur)) : total;
    var out = [];
    for (var i = 0; i < lines.length; i++) {
        var chars = Array.from(lines[i]);
        if (n <= 0) { out.push(''); continue; }
        out.push(chars.slice(0, n).join(''));
        n -= chars.length;
    }
    return out;
}

function drawOne(ctx, it, alpha, W, H, ph) {
    var b = boxOf(ctx, it, W, H), m = b.m;
    if (!m.lines.length) return;
    var anim = it.anim || 'fade';
    var pin = ph && ph.pin != null ? ph.pin : 1;

    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.font = fontSpec(it, m.fontPx);
    ctx.textBaseline = 'alphabetic';
    ctx.direction = isRtl(it.text) ? 'rtl' : 'ltr';

    var top = b.y, pad = b.pad, boxX = b.x;
    // Выезд — снизу на 8 % кадра; всплытие — масштаб из 60 % с перелётом.
    if (anim === 'slide' && pin < 1) top += (1 - easeOut(pin)) * 0.08 * H;
    if (anim === 'pop' && pin < 1) {
        var s = 0.6 + 0.4 * easeBack(pin);
        var ccx = boxX + m.w / 2, ccy = top + m.h / 2;
        ctx.translate(ccx, ccy); ctx.scale(s, s); ctx.translate(-ccx, -ccy);
    }
    var lines = anim === 'type' ? typedLines(m.lines, ph) : m.lines;

    var bgc = it.bgColor || '#000000';
    if (it.bg === 'box') {
        // Чёрная плашка — полупрозрачная (классическая подложка субтитров),
        // цветная — плотная: цветная полупрозрачная выходит грязной.
        ctx.fillStyle = rgba(bgc, bgc === '#000000' ? 0.55 : 0.92);
        var r = Math.round(m.fontPx * 0.25);
        roundRect(ctx, boxX - pad, top - pad * 0.6, m.w + pad * 2, m.h + pad * 1.2, r);
        ctx.fill();
    }
    if (it.bg === 'glow') {
        // Свечение: размытая тень цвета подложки. Размер — от кегля, иначе
        // на 4K оно станет ниткой, а в превью — пятном.
        ctx.shadowColor = rgba(bgc, 0.95);
        ctx.shadowBlur = Math.max(4, Math.round(m.fontPx * 0.45));
    }

    var rtl = ctx.direction === 'rtl';
    ctx.textAlign = it.align === 'left' ? 'left' : (it.align === 'right' ? 'right' : 'center');
    var tx = it.align === 'left' ? boxX : (it.align === 'right' ? boxX + m.w : boxX + m.w / 2);
    // Печать пишет строку с ЕЁ начала (слева, у арабского — справа) там, где
    // строка встанет целиком: иначе при центровке она «разъезжалась» бы от
    // середины.
    if (anim === 'type') ctx.textAlign = rtl ? 'right' : 'left';

    for (var k = 0; k < lines.length; k++) {
        if (!lines[k]) continue;
        var by = top + m.lineHeight * k + Math.round(m.fontPx * 0.98);
        var lx = tx;
        if (anim === 'type') {
            var fw = ctx.measureText(m.lines[k]).width;
            var x0 = it.align === 'left' ? boxX : (it.align === 'right' ? boxX + m.w - fw : boxX + (m.w - fw) / 2);
            lx = rtl ? x0 + fw : x0;
        }
        if (it.bg === 'shadow') {
            // Обводка, а не тень: тень исчезает на пёстром фоне ровно там, где
            // она нужна. Толщина от кегля — иначе на 4K она станет ниткой.
            ctx.lineWidth = Math.max(2, Math.round(m.fontPx * 0.14));
            ctx.lineJoin = 'round';
            ctx.miterLimit = 2;
            ctx.strokeStyle = rgba(bgc, 0.8);
            ctx.strokeText(lines[k], lx, by);
        }
        ctx.fillStyle = it.color || '#ffffff';
        ctx.fillText(lines[k], lx, by);
    }
    ctx.restore();
}
function roundRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
}

window.VideoEditorOverlay = {
    draw: draw, measure: measure, boxOf: boxOf, ensureFonts: ensureFonts,
    onFontReady: function (fn) { if (typeof fn === 'function') readyHooks.push(fn); },
    FONTS: Object.keys(FONTS), FONT_STACK: FONT_STACK, _isRtl: isRtl, _typedLines: typedLines, _wrapLine: wrapLine,
};
})();
